<template>
  <div>
    <q-dialog v-model="show" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{this.$gettext('GENERATE_ORDER')}}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container id="generator-order-container">
          <crud-layout-page
            v-if="!detail"
            :params="params"
            :forms="forms"
            @action-button="actionButton"
            @show-message="showMessage"
            @composition-button-click="
              (butt) => $emit('composition-button-click', butt)
            "
          >
            <slot
              name="form"
              slot="form"
              :form="forms[0]"
              :actionButton="actionButton"
              form-class="form dynamic"
              style="max-height: 45px"
            >
            </slot>
          </crud-layout-page>
          <crud-layout-page-detail
            v-if="detail"
            :params="params"
            :forms="forms"
            @action-button="actionButton"
            @show-message="showMessage"
            class="detail"
          />
        </q-page-container>
      </q-layout>
    </q-dialog>
    <div>
      <q-dialog ref="dialog">
        <q-card class="q-dialog-plugin">
          <q-card-section class="row justify-center">
            <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
          </q-card-section>
          <q-card-section class="row justify-center q-mx-lg">
            <span class="text-subtitle1 text-weight-medium text-center">
              <translate v-if="groupBillingOrder">{{`${this.$gettext('GROUPING_NOTICE')}` }}</translate>
              <translate v-else>WARNING_NO_GROUPING</translate>
            </span>
          </q-card-section>
          <q-card-actions class="justify-center q-pa-md q-my-sm">
            <q-btn
              :label="$gettext('CANCEL')"
              color="grey-7"
              @click="onCancelClick"
              class="q-px-lg"
            />
            <q-btn
              :label="$gettext('OK')"
              color="info"
              @click="onOKClick"
              class="q-px-lg"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail, page } = JtCrud
import { QDialog, Dialog } from 'quasar'
import { messageBox } from 'jtech'

@Component({
  mixins: [page],
  name: 'GeneratorOrderEmissionModal',
  components: {
    page,
    pageDetail,
    QDialog,
    Dialog
  },
  props: {
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    show: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    itemsLateGroup: {
      type: Array,
      default: []
    }
  }
})
class GeneratorOrderEmissionModal extends Vue {
  modalData = {};
  groupBillingOrder = null;
  buttonClick = '';

  actionButton (button, params, page) {
    if ((button.name == 'btSaveOrder') && params.emission) {
      this.buttonClick = button.name
      if (this.itemsLateGroup.length > 0) {
        this.itemsLateGroup.forEach(order => {
          if (params[`order-${order.id}`]) {
            order.groupOrder = params[`order-${order.id}`]
          } else {
            order.groupOrder = null
          }
        })

        this.groupBillingOrder = params.groupBillingOrder
        this.modalData.button = button
        this.modalData.params = params
        this.$refs.dialog.show()
      } else {
        this.actionButtonSave(button, params)
      }
    } else {
      messageBox.warn(this.$gettext('FILL_ISSUE_DATE_SELECTED_ITEMS'))
    }
  }

  actionButtonSave (button, params) {
    params.buttonClick = this.buttonClick
    this.$emit('action-button', button, params)
  }

  onOKClick () {
    this.$refs.dialog.hide()
    this.actionButtonSave(this.modalData.button, this.modalData.params)
  }

  onCancelClick () {
    this.$refs.dialog.hide()
  }

  hide () {
    this.show = false
  }
}

export default GeneratorOrderEmissionModal
</script>
<style lang="stylus" scoped>
#generator-order-container {
  .q-card {
    height: 65vh;
  }
}
</style>
